import { Layout as AntdLayout } from 'antd';
import styled, { css } from 'styled-components';

import { staticCdnHost } from '@rockalingua/ui/constants/Cdn';
import Colors from '@rockalingua/ui/constants/Colors';
import MediaQueryBreakpoints from '@rockalingua/ui/constants/MediaQueryBreakpoints';
import {
  maxWidth,
  padding,
  compactPadding,
} from '@rockalingua/ui/constants/Layout';

const publicPageDropImagePath = `${staticCdnHost}/img/public-page/drop.svg`;

export const backgroundVariants = {
  default: 'default',
  main: 'main-20',
  twoDrops: 'two-drops',
} as const;

export type BackgroundVariant =
  (typeof backgroundVariants)[keyof typeof backgroundVariants];

function getBackgroundStyles(variant: BackgroundVariant) {
  switch (variant) {
    case backgroundVariants.twoDrops:
      return css`
        background-image:
          url('${publicPageDropImagePath}'), url('${publicPageDropImagePath}');
        background-repeat: no-repeat;
        background-position: calc(50vw - min(750px, 58.59375vw))
          max(-250px, -19.53125vw);
        background-size: min(600px, 46.875vw);
      `;
    case backgroundVariants.main:
      return css`
        background: ${Colors.MAIN_VARIANTS[20]};
      `;
    case backgroundVariants.default:
    default:
      return css`
        background: ${Colors.WHITE};
      `;
  }
}

export const Container = styled.div<{ $backgroundVariant: BackgroundVariant }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow-x: clip;

  ${(props) => getBackgroundStyles(props.$backgroundVariant)}

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
  }
`;

export const Layout = styled(AntdLayout)`
  width: 100%;
  max-width: ${maxWidth}px;
  padding: ${padding}px;
  min-height: 100vh;

  @media (${MediaQueryBreakpoints.isUltraWide}) {
    padding: ${compactPadding}px;
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.sm}px) {
    padding: ${compactPadding}px;
  }
`;

export const Content = styled(AntdLayout.Content)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  border-radius: 12px;

  @media (${MediaQueryBreakpoints.isUltraWide}) {
    gap: 8px;
  }
`;
